<div class="ui-cake-counter-theme-wrapper ws-counter">
  <div class="d-flex {{ 'counter-' + size }}">
    <div (click)="$event.stopPropagation()">
      <button class="btn-count-control ws-counter__button {{btnStyle}}"
              [class.btn-highlighted]="btnHighlighting"
              [disabled]="minusDisablingCheck() || isMinusDisabled"
              (click)="$event.stopPropagation(); shiftCount(false)">
        <i class="icon-minus counter-control"></i>
      </button>
    </div>

    @if (isAllowEnterCounter) {
      <input class="count text-center fw-bold input-counter ws-counter__value"
             [class.mx-2]="size === 'xs' || size === 'sm'"
             [class.compact-counter-input]="size === 'xs' || size === 'sm'"
             type="number"
             [min]="minCount"
             [max]="maxCount"
             [pattern]="positiveNumberPattern"
             (click)="$event.stopPropagation()"
             [(ngModel)]="count"
             (ngModelChange)="inputCounterChanged($event)"/>
    } @else {
      <span class="count text-center fw-bold ws-counter__value">
        {{ count }}
      </span>
    }

    <div (click)="$event.stopPropagation()">
      <button class="btn-count-control ws-counter__button {{btnStyle}}"
              [class.btn-highlighted]="btnHighlighting"
              [disabled]="plusDisablingCheck() || isPlusDisabled"
              (click)="$event.stopPropagation(); shiftCount(true)">
        <i class="icon-plus counter-control"></i>
      </button>
    </div>
  </div>
</div>
